import ReviewsResults from 'components/state-reviews/ReviewsResults'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function Reviews({ ...props }) {
	const { standard, language } = useContext(CoreAdoptionContext)
	const standardCapitalized = standard.toUpperCase() as 'CCSS' | 'TEKS'
	return (
		<div id={formatSectionId(props)}>
			<ReviewsResults stateReviewsButton standard={standardCapitalized} language={language} />
		</div>
	)
}
